<template>
    <div class="g-ps-main-tab-div">
        <b-tabs content-class="mt-3">
            <b-tab title="Product & services" active @click="onTabChange('PGProductServicesSetting')">
                <pg-product-and-services-settings ref="PGProductServicesSetting"></pg-product-and-services-settings>
            </b-tab>
            <b-tab title="Manage categories" @click="onTabChange('PGCategorySetting')">
                <pg-category-settings ref="PGCategorySetting"></pg-category-settings>
            </b-tab>
            <b-tab title="Sales tax settings" @click="onTabChange('PGSalesTaxSetting')">
                <pg-sales-tax-settings ref="PGSalesTaxSetting"></pg-sales-tax-settings>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import PgProductAndServicesSettings from "./pg-product-and-services-settings.vue";
import PgSalesTaxSettings from "./pg-sales-tax-settings.vue";
import PgCategorySettings from "./pg-category-settings.vue";

export default {
    name: "proposal-settings-product-and-services-main-tab",
    props:[],
    components: {
        PgCategorySettings,
        PgSalesTaxSettings,
        PgProductAndServicesSettings
    },
    data() {
        return {}
    },
    mounted(){

    },
    methods: {
        onTabChange(ref) {
            if(ref === 'PGProductServicesSetting') {
                this.$refs.PGProductServicesSetting.getAllPGCategoriesCompleteData();
                this.$refs.PGProductServicesSetting.getAllPGProductServices();
                this.$refs.PGProductServicesSetting.getFieldData();
            }
            if(ref === 'PGCategorySetting') {
                this.$refs.PGCategorySetting.getAllPGCategories();
            }
            if(ref === 'PGSalesTaxSetting') {
                this.$refs.PGSalesTaxSetting.getAllSalesTax();
            }
        }
    }
};
</script>

<style>
.pg-ps-main-tab-div .nav-tabs {
    background-color: #f1f5f8 !important;
    color: #3d4852 !important;
}

.pg-ps-main-tab-div .nav-tabs .nav-link {
    border: none !important;
    color: #3d4852 !important;
}

.pg-ps-main-tab-div .nav-tabs .nav-link.active {
    background-color: transparent !important;
    border-bottom: 2px solid #01b1af !important;
    color: #01b1af !important;
}
</style>
